import { persistor } from '@/store';

export const logout = () => {
  try {
    persistor.purge();
    localStorage.removeItem('token');
    window.location.reload();
  } catch (e) {
    console.error(JSON.stringify(e));
  }
};

export const downloadAsBlob = async (url, name) => {
  try {
    if (!url || !name) {
      throw new Error('Response and name parameters are required');
    }
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(response.statusText || 'Something went wrong...');
    }

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = downloadUrl;
    a.download = `${name}.bpmn`; // Use the name parameter for the file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // Remove the element after clicking
    URL.revokeObjectURL(downloadUrl);
  } catch (error: any) {
    console.error('Caught an error:', error.message); // Log the error to the console
    throw new Error(error?.message || 'Something went wrong...');
  }
};
